export default __webpack_public_path__ + "static/media/rotor_placed.a5fc8ef8.svg";